import React from 'react'
import {Icon} from '@chakra-ui/react'

const ZoomInIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path d="M9 9V5H11V9H15V11H11V15H9V11H5V9H9Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 10C19 12.1201 18.2669 14.069 17.0404 15.6071L24 22.5667L22.5667 24L15.6071 17.0404C14.069 18.2669 12.1201 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ZoomInIcon
